import { Container, Stack } from '@mui/material';
import i18next from 'i18next';

import { RiveAnimation } from '@frontend-libs/portal';

import { tApp } from '@frontend/locales';

export const Loading = () => {
  return (
    <Container component="main" maxWidth="xs">
      <Stack
        spacing={2}
        height="100vh"
        justifyContent="center"
        alignItems="center"
        component="output"
        role="status"
        aria-label={
          i18next.exists('app:app.notifications.loading')
            ? tApp.app.notifications.loading()
            : 'Loading'
        }
      >
        <RiveAnimation src="/rive/loading.riv" height={128} />
      </Stack>
    </Container>
  );
};
